"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiSelect = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_icons_1 = require("@radix-ui/react-icons");
var stitches_config_1 = require("../stitches.config");
var Dropdown_1 = require("./Dropdown");
var DropdownItem_1 = require("./DropdownItem");
var StyledInputContainer = (0, stitches_config_1.styled)("div", {
    width: "93%",
    display: "flex",
    flexDirection: "row",
    overflow: "auto",
    gap: "4px",
    whiteSpace: "nowrap",
    "&::-webkit-scrollbar": {
        display: "none",
    },
    padding: "2px 8px",
});
var SelectButton = (0, stitches_config_1.styled)("div", {
    width: "360px",
    cursor: "pointer",
    height: "40px",
    display: "flex",
    borderStyle: "solid",
    borderWidth: "1px",
    background: stitches_config_1.theme.colors.white,
    borderRadius: stitches_config_1.theme.shape.borderRadius,
    borderColor: stitches_config_1.theme.colors.gray7,
    flexDirection: "row",
    alignItems: "center",
    variants: {
        fullWidth: {
            true: {
                width: "100%",
            },
        },
    },
});
var StyledCheckIcon = (0, stitches_config_1.styled)(react_icons_1.CheckIcon, {
    width: "15px",
});
var CheckPlaceholder = (0, stitches_config_1.styled)("div", {
    width: "15px",
    height: "100%",
    display: "flex",
    alignItems: "center",
});
function MultiSelect(props) {
    return ((0, jsx_runtime_1.jsxs)(Dropdown_1.Dropdown, __assign({ button: (0, jsx_runtime_1.jsxs)(SelectButton, __assign({ fullWidth: props.fullWidth }, { children: [(0, jsx_runtime_1.jsx)(StyledInputContainer, { children: props.renderSelectedOptions
                        ? props.renderSelectedOptions(props.selectedValues, props.options)
                        : props.selectedValues.map(function (selectedValue, i) {
                            var selectedOption = props.options.find(function (option) { return option.value === selectedValue; });
                            return (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.label) ? (props.csv && i !== props.selectedValues.length - 1 ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [selectedOption.label, ", "] })) : (selectedOption.label)) : (selectedValue);
                        }) }), (0, jsx_runtime_1.jsx)(react_icons_1.ChevronDownIcon, {})] })) }, { children: [props.options.map(function (option) {
                return ((0, jsx_runtime_1.jsx)(DropdownItem_1.DropdownItem, { text: option.label, onClick: function () {
                        if (props.selectedValues.indexOf(option.value) !== -1) {
                            var valuesCopy = __spreadArray([], props.selectedValues, true);
                            props.onChange(valuesCopy.filter(function (val) { return val !== option.value; }));
                        }
                        else {
                            props.onChange(__spreadArray(__spreadArray([], props.selectedValues, true), [option.value], false));
                        }
                    }, startIcon: props.selectedValues.indexOf(option.value) !== -1 ? ((0, jsx_runtime_1.jsx)(CheckPlaceholder, { children: (0, jsx_runtime_1.jsx)(StyledCheckIcon, {}) })) : ((0, jsx_runtime_1.jsx)(CheckPlaceholder, {})) }));
            }), props.additionalOptions && props.additionalOptions] })));
}
exports.MultiSelect = MultiSelect;
//# sourceMappingURL=MultiSelect.js.map